var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.435,
    height: 19.435,
    viewBox: "0 0 19.435 19.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8504",
    "data-name": "Rectangle 8504",
    width: 19.435,
    height: 19.435,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16235",
    "data-name": "Group 16235",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5884",
    "data-name": "Path 5884",
    d: "M6.536,7.243a3,3,0,0,1,4.113-.121l.129.121.708.707a1,1,0,0,1-1.328,1.492l-.087-.078-.708-.707a1,1,0,0,0-1.327-.078l-.086.078L2.292,14.314a1,1,0,0,0-.077,1.327l.077.087,1.415,1.414a1,1,0,0,0,1.328.078l.087-.078,3.534-3.535a1,1,0,0,1,1.493,1.327l-.078.087L6.536,18.557a3,3,0,0,1-4.114.121l-.13-.121L.878,17.142a3,3,0,0,1-.121-4.114L.878,12.9ZM12.9.879A3,3,0,0,1,17.014.758l.128.121,1.414,1.414a3,3,0,0,1,.121,4.115l-.121.128L12.9,12.193a3,3,0,0,1-4.114.121l-.129-.121-.706-.707A1,1,0,0,1,9.276,9.994l.087.077.708.707a1,1,0,0,0,1.327.078l.088-.078,5.656-5.656A1,1,0,0,0,17.219,3.8l-.077-.088L15.727,2.293A1,1,0,0,0,14.4,2.216l-.088.077L10.778,5.829A1,1,0,0,1,9.286,4.5l.077-.087Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksLink);
export default __webpack_public_path__ + "static/media/tasks-link.44d2143c38f0ba4012b657ffdce1d336.svg";
export { ForwardRef as ReactComponent };